var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('h4',{staticClass:"title"},[_vm._v("花城"+_vm._s(_vm.monthObj[_vm.currentMOnth] || 0)+"月赏花地图")]),_c('div',{staticClass:"img",on:{"click":_vm.openMap}}),_c('div',{staticClass:"tip"},[_vm._v("点击图片查看详细内容")])])
}
var staticRenderFns = []

export { render, staticRenderFns }